const BASE_URL = "https://rest.gohighlevel.com/v1";
const V2_BASE_URL = "https://services.leadconnectorhq.com";

const APIs = {
  oauth: `${V2_BASE_URL}/oauth/token`,
  v2: {
    location: (locationId) => `${V2_BASE_URL}/locations/${locationId}`,
    company: (companyId) => `${V2_BASE_URL}/companies/${companyId}`,
    custom_fields: (locationId) =>
      `${V2_BASE_URL}/locations/${locationId}/customFields`,
    workflows: (locationId) => `${V2_BASE_URL}/workflows/?locationId=${locationId}`,
  },
  v1: {
    location: `${BASE_URL}/locations`,
    custom_fields: `${BASE_URL}/custom-fields/`,
    workflows: `${BASE_URL}/workflows/`,
  },
};

// Mirrors Apps.appType / Apps.whoCanInstall on the backend.
const AppTypes = {
  AGENCY: "Agency",
  SUB_ACCOUNT: "Sub Account",
};

const WhoCanInstall = {
  ANYONE: "Anyone",
  ONLY_ME: "Only Me",
};

const InstallStatus = {
  INSTALL: "INSTALL",
  UNINSTALL: "UNINSTALL",
};

/**
 * What an app plugs into on the CRM side. Stored on
 * Apps.featuresInclude as an array of these labels.
 *
 * The value is the label — it is what gets written to the database and shown on
 * the public page, so changing a string here changes existing records' meaning.
 */
const AppFeatures = {
  ACTIONS: "Actions",
  TRIGGERS: "Triggers",
  CONVERSATION_PROVIDER: "Conversation Provider",
  PAYMENT_PROVIDER: "Payment Provider",
  WIDGET: "Widget",
  VOICE_AI: "Voice AI",
  CONVERSATION_AI: "Conversation AI",
  SNAPSHOTS: "Snapshots",
};

// Short helper text shown beside each option in the admin picker.
const AppFeatureHints = {
  [AppFeatures.ACTIONS]: "Steps the app adds to workflows",
  [AppFeatures.TRIGGERS]: "Events the app fires into workflows",
  [AppFeatures.CONVERSATION_PROVIDER]: "Sends and receives messages on a channel",
  [AppFeatures.PAYMENT_PROVIDER]: "Takes payments inside your CRM",
  [AppFeatures.WIDGET]: "Embedded UI in the dashboard",
  [AppFeatures.VOICE_AI]: "Handles calls with an AI agent",
  [AppFeatures.CONVERSATION_AI]: "Replies in conversations with AI",
  [AppFeatures.SNAPSHOTS]: "Ships prebuilt account configuration",
};

export {
  APIs,
  AppTypes,
  WhoCanInstall,
  InstallStatus,
  AppFeatures,
  AppFeatureHints,
};
